import ReactSelect from 'react-select'

export interface SmallDropdownProps {
    options: any[]
    onChange: (value: any) => void
    defaultValue: any
}
export function SmallDropdown({
    options,
    onChange,
    defaultValue,
}: SmallDropdownProps) {
    return (
        <ReactSelect
            className='react-select-dropdown'
            options={options}
            defaultValue={options[0]}
            value={defaultValue}
            onChange={(selection: any) => {
                onChange(selection.value)
            }}
            styles={{
                control: provided => ({
                    ...provided,
                    borderWidth: 0,
                    borderRadius: '8px',
                    boxShadow: '0px 5px 8px 0px rgba(0,0,0,0.33)',
                    maxWidth: '200px',
                    minWidth: '140px',
                    height: 28,
                    minHeight: 28,
                    padding: 0,
                }),
                valueContainer: provided => ({
                    ...provided,
                    width: '100%',
                    paddingLeft: 12,
                    marginTop: -4,
                    fontSize: 12,
                }),
                indicatorSeparator: () => ({
                    display: 'none',
                }),
                indicatorsContainer: provided => ({
                    ...provided,
                    marginTop: -3,
                }),
                option: (styles, { isDisabled, isFocused, isSelected }) => {
                    return {
                        ...styles,
                        padding: 4,
                        backgroundColor: isSelected
                            ? '#0F52BA'
                            : isFocused
                            ? '#00000030'
                            : '#fff',
                        fontSize: 12,
                        cursor: isDisabled ? 'not-allowed' : 'default',
                    }
                },
            }}
        />
    )
}
